export enum Currency {
  EUR = 'EUR',
  CHF = 'CHF',
  USD = 'USD'
}

/* Special primitives */
export type DateTimeString = string // todo define
export type EmailString = string // todo define // maxlength: 255
export type PhoneString = string // todo define
export type Integer = number


export interface LangedItem {
  languageCode: string
  value?: string
}

/**
 * Represents string in format YYYY-MM-DD
 */
export type DateString = string
